<div class="d-flex flex-wrap">
  <div class="d-flex justify-content-center col-md-6 col-sm-12" *ngFor="let element of modelList; let i = index;">
    <figure class="news-card">
      <div class="image w-100">
        <!-- <img class="picture" [src]="element.imgUrl" alt="Not Found" onerror="this.src='../../../assets/img/placeholder-centro-funzionale.jpg';"/> -->
        <!-- <img class="picture"
          src="https://centrofunzionale.regione.campania.it/img/articoli/b6ff13c0c4c84b07ac9f971c8e6496f1"
          alt="Not Found"> -->
        <img class="picture" [src]="getImageSrcById(element.imgId)" [title]="getImageSrcById(element.title)"
          alt="Not Found" />
      </div>
      <figcaption>
        <!-- <div class="date"><span class="day">{{news.giorno}}</span><span class="month">{{news.mese}}</span></div> -->
        <h4>{{ element.titolo }}</h4>
        <hr>
        <div style="color: #989696;">
          <span style="font-style: italic">Data: </span>
          <span style="font-weight:bold;">{{ element.dataInserimento }}</span>
        </div>
      </figcaption>
      <a href="javascript:void(0)" (click)="routeTo(element.idArticolo)"></a>
    </figure>
  </div>
</div>